import { UserLight } from '@/types/authent/login.types';

import { AlertLevelEnum } from '../data/data.types';

export type LightMessage = {
  site: string;
  msg: string;
};

export type Message = LightMessage & {
  id: number;
  author: UserLight | null;
  time: string;
};

export enum MessageRequestMediaEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export type Contact = {
  id: number;
  site: string;
  platform: string;
  code: string;
  name: string;
  active: boolean;
  media: MessageRequestMediaEnum;
  locale: string;
  zone: string;
  contact: string;
  subscriptions: string[];
};

export enum MessageRequestTemplateEnum {
  NFZ_ENTRY = 'NFZ_ENTRY',
  NFZ_EXIT = 'NFZ_EXIT',
  DRONE_LOST = 'DRONE_LOST',
  PERIMETER_EFFRACTION = 'PERIMETER_EFFRACTION',
  SENSOR_FAILURE = 'SENSOR_FAILURE',
}

export enum MessageRequestStatusEnum {
  TO_SEND = 'TO_SEND',
  TO_RETRY = 'TO_RETRY',
  ERROR = 'ERROR',
  SENT = 'SENT',
}

export type MessageRequestContent = {
  time: string;
  template: MessageRequestTemplateEnum;
  subject: string | null;
  text: string | null;
  params: Record<string, unknown>;
  alertLevel: AlertLevelEnum;
};

export type MessageRequest = {
  id: number;
  site: string;
  platform: string;
  code: string;
  status: MessageRequestStatusEnum;
  content: MessageRequestContent;
  sourceId: string | null;
  contactIdsInError: number[];
};

export type MessageRenderRequest = {
  id: number;
  locale: string;
  zone: string;
};

export type MessageRenderResponse = {
  subject: string;
  text: string;
};
